import script from "./webIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./webIndex.vue?vue&type=script&setup=true&lang=js"

import "./webIndex.vue?vue&type=style&index=0&id=7e7df61c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7e7df61c"]])

export default __exports__